exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item[data-v-2a47aa4f] {\n  position: relative;\n}\n.item[data-v-2a47aa4f]:before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 0.05rem;\n  background-image: linear-gradient(0deg, #e0e0e0 50%, transparent 0);\n  position: absolute;\n  bottom: 0;\n}\n.cell_title[data-v-2a47aa4f] {\n  color: inherit;\n  font-weight: inherit;\n  max-width: 15.5rem;\n}\n.cell_cont[data-v-2a47aa4f] {\n  font-weight: initial;\n}\n.paddingli li[data-v-2a47aa4f] {\n  padding: 0 0.75rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n.brackets[data-v-2a47aa4f] {\n  display: inline-block;\n  width: 0.4rem;\n}", ""]);

// exports
